import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { withSwal } from "react-sweetalert2";
import AppContext from "../../context/AppContext";

import axios from "axios";

const SellDevice = ({ isVisible, hideModel, swal }) => {
  const { baseUrl, currentAddress } = useContext(AppContext);

  const [booking, setBooking] = useState({});
  const [aptSubmitLoading, setAptSubmitLoading] = useState(false);
  const [formValidate, setFormValidate] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const errors = {};

    if (!booking.name) {
      errors.name = "Name is required";
    }
    if (!booking.email) {
      errors.email = "Email is required";
    }
    if (!booking.phone) {
      errors.phone = "Phone# is required";
    }

    setErrorMessages(errors);
    if (Object.keys(errors).length === 0) {
      storeBooking();
      // alert("Alright");
    } else {
      swal.fire({
        title: "Error",
        text: "Something went wrong please try agian later.",
        icon: "error",
      });
      // hideModel();
      setFormValidate(true);
    }
  };
  const storeBooking = () => {
    setAptSubmitLoading(true);
    const formData = new FormData();
    formData.append("name", `${booking.name}`);
    formData.append("phone", `${booking.phone}`);
    formData.append("email", `${booking.email}`);
    formData.append("video", booking.video);

    formData.append("message", `${booking.message}`);
    formData.append("status", `upcoming`);
    formData.append("type", `sell`);

    axios({
      method: "post",
      url: `${baseUrl}/api/guest/storeAppointmentDetails`,
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    })
      .then((response) => {
        console.log(response);
        console.log("/////////////Contact Form Response/////////////");
        console.log(response.data);
        if (response.data.success == "ok") {
          // alert("Form submitted successfully");
          hideModel();
          swal.fire({
            title: "Success",
            text: "Your data has been submitted. You will be contacted soon.",
            icon: "success",
          });
          setAptSubmitLoading(false);
        }

        setBooking({});
      })
      .catch((error) => {
        console.log(error);
        hideModel();
        swal.fire({
          title: "Error",
          text: "Something went wrong please try agian later.",
          icon: "error",
        });
        setAptSubmitLoading(false);
      });
  };

  useEffect(() => {
    setBooking((prev) => ({
      ...prev,
      pickupLocation: currentAddress,
      dropOffLocation: currentAddress,
    }));
  }, [currentAddress]);
  return (
    <Modal
      centered
      show={isVisible}
      onHide={hideModel}
      className=""
      // size={isDesktopOrLaptop ? "lg" : "sm"}
      // size={"md"}
    >
      <Modal.Header closeButton className="bg-green" style={{ border: "none" }}>
        <h5 className="poppins-semiBold ms-3 text-light">
          Sell Your Phone – Get a Quick Quote
          <br />
          <span style={{ fontSize: 14 }}>
            Experience a premium and effortless way to sell your phone in
            Brighton & Hove. Share a few details, and our team will present you
            with a competitive offer tailored to the true value of your device.
            Swift, secure, and discreet.
          </span>
        </h5>
      </Modal.Header>

      <Modal.Body className="">
        <Form
          noValidate
          validated={formValidate}
          onSubmit={handleSubmit}
          className="ms-3"
        >
          <Container fluid className="py-3 px-0 ">
            <Row className="g-3">
              <Form.Text className="poppins-medium txt-green ">
                Personal Info
              </Form.Text>
              <Col xs={12} md={12} lg={12} className="my-3">
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Control
                    className="poppins-regular input"
                    type="text"
                    placeholder="Name"
                    size="md"
                    value={booking.name || ""}
                    onChange={(e) =>
                      setBooking({ ...booking, name: e.target.value })
                    }
                    required
                  />
                  {errorMessages.name && (
                    <p className="text-danger">{errorMessages.name}</p>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} md={12} lg={12} className={`my-3`}>
                <Form.Group controlId="exampleForm.ControlInput2">
                  <Form.Control
                    className="poppins-regular input"
                    type="tel"
                    placeholder="Phone number"
                    pattern="[0-9]{10}"
                    size="md"
                    value={booking.phone || ""}
                    onChange={(e) =>
                      setBooking({ ...booking, phone: e.target.value })
                    }
                    required
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={12} lg={12} className={`my-3`}>
                <Form.Group controlId="exampleForm.ControlInput3">
                  <Form.Control
                    className="poppins-regular input "
                    type="email"
                    placeholder="E-mail"
                    size="md"
                    value={booking.email || ""}
                    onChange={(e) =>
                      setBooking({ ...booking, email: e.target.value })
                    }
                    required
                  />
                  <p style={{ fontSize: 10 }}>
                    Email must be correct so that our team can send you qoute.
                    Your email will not be used for any marketing purpose.
                  </p>
                </Form.Group>
              </Col>
              <Form.Text className="poppins-medium txt-green ">
                Your Phone Video (that clearly show condition)
              </Form.Text>
              <Col xs={12} md={12} lg={12} className={`my-3`}>
                <Form.Group controlId="exampleForm.ControlInput3">
                  <Form.Control
                    className="poppins-regular input "
                    type="file"
                    placeholder="Broken Phone Video"
                    size="md"
                    onChange={(e) =>
                      setBooking({ ...booking, video: e.target.files[0] })
                    }
                    required
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={12} lg={12} className={`my-3`}>
                <Form.Group
                  className="my-2 "
                  controlId="exampleForm.ControlInput8"
                >
                  <Form.Control
                    as="textarea"
                    rows={3}
                    className="poppins-regular input "
                    placeholder="Other details here. i:e Battery Health, genuine parts or repaired parts"
                    value={booking.message || ""}
                    onChange={(e) =>
                      setBooking({ ...booking, message: e.target.value })
                    }
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            {aptSubmitLoading ? (
              <div className="d-flex flex-column justify-content-center align-items-center">
                <Spinner size="sm" />
              </div>
            ) : (
              <Button
                type="submit"
                size="md"
                className="poppins-semiBold  mt-4 mx-3 border-0 orange-block-btn"
              >
                Submit
              </Button>
            )}
          </Container>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default withSwal(SellDevice);
